import { SwiperContainer } from "./../_module/_carousel/swiper";
import { Opening } from "./../_module/_animation/opening";
import { LetterMotion } from "./../_module/_text/letterMotion";

import { Locomo } from "./../_module/_scroll/locomo";

export const NewsLow = {
  /**
   * funcs
   */
  init: () => {
    // HeadSnowAni.setCanvas()
    SwiperContainer.init();
    Opening.lowPageReady()
    LetterMotion.init(true)

    setTimeout(()=>{
      Locomo.update();
    },1000)
  },
};
